import { FC, useContext, useMemo } from 'react';

import {
  GroupedCoverageCardsList,
} from '../../../../../shared/components';

import {
  GenericDataFormContext,
  QuotationInfoContext,
} from '../../../../../shared/contexts';
import { StepFourFormContext } from '../../contexts/StepFourForm';
import { StepThreeFormContext } from '../../../StepThree/contexts/StepThreeForm';

import {
  groupCardsByCommonSection,
  GroupedCoveragesCardsResult,
} from '../../../../../utils';
import { ContentSection } from '../../../../../../../../../shared/components';

interface CoveragesFireSectionProps {
  tabKey: number;
}

export const CoveragesFireSection: FC<CoveragesFireSectionProps> = ({
  tabKey,
}) => {
  const { stepFourFireQuotationForm } = useContext(StepFourFormContext);
  const { allCoveragesPerPlan, getRelationWithOtherCoverage } = useContext(GenericDataFormContext);
  const { stepThreeForm, plansByActivityList } =
    useContext(StepThreeFormContext);
   const { quotationInfo } = useContext( QuotationInfoContext );

  const planSelected = stepThreeForm?.getFieldValue(`plan-tab-${tabKey}`);

  const planSelectedLabel =
    plansByActivityList.find((el) => el.value === planSelected)?.label ?? '';

  const allCoveragesByTab = useMemo(
    () =>
      allCoveragesPerPlan?.find(
        (el) => String(el.plan as string) === String(planSelected)
      )?.coverages,
    [allCoveragesPerPlan, planSelected]
  );

  const groupedCoveragesCardsResult: GroupedCoveragesCardsResult =
    useMemo(() => {
      return allCoveragesByTab
        ? groupCardsByCommonSection(allCoveragesByTab, 'codigoFamilia')
        : {};
    }, [allCoveragesByTab, planSelectedLabel]);

  return (
    <ContentSection level='h3' title='Coberturas' hasCard={false}>
      {Object.keys(groupedCoveragesCardsResult).map((key, index) => {
        if (!groupedCoveragesCardsResult[key].title) {
          return (
            <GroupedCoverageCardsList
              key={key}
              quotationInfo={quotationInfo}
              groupedCoverageKey={key}
              groupedCoveragesCardsResult={groupedCoveragesCardsResult}
              tabKeyForm={`fire-tab-${tabKey}`}
              usedFormToCoverageCard={stepFourFireQuotationForm}
              allCoveragesByTabList={allCoveragesByTab ?? []}
              getRelationWithOtherCoverage={getRelationWithOtherCoverage}
              className={index !== 0 ? 'mt-2' : 'grouped-coverages-first-title'}
            />
          );
        }
      })}

      {Object.keys(groupedCoveragesCardsResult).map((key, index) => {
        if (groupedCoveragesCardsResult[key].title) {
          return (
            <GroupedCoverageCardsList
              key={key}
              quotationInfo={quotationInfo}
              groupedCoverageKey={key}
              groupedCoveragesCardsResult={groupedCoveragesCardsResult}
              tabKeyForm={`fire-tab-${tabKey}`}
              usedFormToCoverageCard={stepFourFireQuotationForm}
              allCoveragesByTabList={allCoveragesByTab ?? []}
              getRelationWithOtherCoverage={getRelationWithOtherCoverage}
              className={index !== 0 ? 'mt-2' : 'grouped-coverages-first-title'}
            />
          );
        }
      })}
    </ContentSection>
  );
};
